export enum UserRole {
    SuperAdmin = 1,
    "Super Admin" = 1,
    CollegeAdmin = 2,
    "College Admin" = 2,
    DepartmentAdmin = 3,
    "Department Admin" = 3,
    Staff = 4,
    Faculty = 5,
    Student = 6,
    Freshman = 7
}